import { Base } from "ui/Scripts/source/framework/base";
import { IPagePanel } from "../common/pagePanel";
import { FrontPageBanner, IFrontPageBanner } from "./frontPageBanner";
import { FrontPageImages, IFrontPageImages } from "./frontPageImages";
import { FrontPagePanel } from "./frontPagePanel";
import { FrontPageRecords, IFrontPageRecords } from "./frontPageRecords";
import { FrontPageMessages, IFrontPageMessages } from "./frontPageMessages";

export interface IFrontPage {
    panels: IPagePanel[];
    banner: IFrontPageBanner;
    images: IFrontPageImages;
    records: IFrontPageRecords;
    messages: IFrontPageMessages;
}

export class FrontPage implements IFrontPage {
    panels: FrontPagePanel[];
    banner: FrontPageBanner;
    images: FrontPageImages;
    records: FrontPageRecords;
    messages: FrontPageMessages;

    constructor();
    constructor(obj: IFrontPage);
    constructor(obj?: any) {
        this.panels = Base.getTypedArray(obj ? obj.panels : null, FrontPagePanel);
        this.banner = new FrontPageBanner(obj && obj.banner || null);
        this.images = new FrontPageImages(obj && obj.images || null);
        this.records = new FrontPageRecords(obj && obj.records || null);
        this.messages = new FrontPageMessages(obj && obj.messages || null);
    }
}